import { useState, useRef, useEffect, useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { serviceGroups } from "../data/services";
import { locationPageUrl } from "../data/locationData";
import { stateData } from "./LocationsSection";
import { stateOutlines } from "./OurLocations";

const serviceIcons = {
  plans: ["M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l5.447 2.724A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"],
  building: ["M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"],
  signs: ["M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"],
  pedestrian: ["M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"],
  closure: ["M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"],
  event: ["M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9"],
  permits: ["M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"],
  council: ["M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"],
  police: ["M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"],
  approval: ["M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"],
  bus: ["M8 7h8M4 17h16M6 21v-1M18 21v-1M5 17V7a2 2 0 012-2h10a2 2 0 012 2v10M8 14h.01M16 14h.01M4 11h16"],
  site: ["M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z", "M15 12a3 3 0 11-6 0 3 3 0 016 0z"],
  pin: ["M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z", "M15 11a3 3 0 11-6 0 3 3 0 016 0z"],
  truck: ["M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z", "M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"],
  crane: ["M4 20h16M6 20V8l8-4M14 4v16M14 8h6v3h-6"],
  mobile: ["M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"],
  vms: ["M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"],
  meeting: ["M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"],
  support: ["M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"],
  aftercare: ["M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"],
  project: ["M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"],
  report: ["M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"],
  analysis: ["M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"],
  swept: ["M4 12a8 8 0 018-8h5", "M13 4l4 4-4 4"],
};

const outlineById = Object.fromEntries(stateOutlines.map((state) => [state.id, state.d]));

function townsIn(state) {
  const seen = new Set();
  const towns = [];
  for (const region of state.regions) {
    for (const suburb of region.suburbs) {
      const key = suburb.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      towns.push(suburb);
    }
  }
  towns.sort((a, b) => a.localeCompare(b, "en"));
  return towns;
}

function StateIcon({ id, className = "h-5 w-5" }) {
  const d = outlineById[id];
  if (!d) return null;
  return (
    <svg className={className} viewBox="0 0 100 100" aria-hidden>
      <path d={d} fill="currentColor" />
    </svg>
  );
}

function ServiceIcon({ name, className = "h-4 w-4" }) {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      {(serviceIcons[name] || serviceIcons.plans).map((d, index) => (
        <path key={index} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d={d} />
      ))}
    </svg>
  );
}

/** Same charcoal as CTA banner (screenshot) */
const PANEL_BG = "#1a1a1a";

const HEADER_LOGO_SRC = encodeURI("/Focus Traffic Plans-Final.png");

function ChevronDown({ className }) {
  return (
    <svg
      className={className}
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

function MenuScroll({ children }) {
  const scrollerRef = useRef(null);
  const [thumb, setThumb] = useState({ visible: false, height: 0, top: 0 });

  const update = () => {
    const el = scrollerRef.current;
    if (!el) return;
    const { scrollHeight, clientHeight, scrollTop } = el;
    const visible = scrollHeight > clientHeight + 1;
    const height = visible ? Math.max(36, (clientHeight / scrollHeight) * clientHeight) : 0;
    const travel = Math.max(0, clientHeight - height);
    const top =
      visible && scrollHeight > clientHeight
        ? (scrollTop / (scrollHeight - clientHeight)) * travel
        : 0;
    setThumb((prev) =>
      prev.visible === visible && prev.height === height && prev.top === top
        ? prev
        : { visible, height, top }
    );
  };

  useLayoutEffect(() => {
    update();
  });

  return (
    <div className="relative max-h-80">
      <div ref={scrollerRef} onScroll={update} className="menu-scroll max-h-80 overflow-y-auto pr-4">
        {children}
      </div>
      {thumb.visible && (
        <div
          aria-hidden
          className="pointer-events-none absolute inset-y-0 right-1.5 w-2 rounded-full bg-white/20"
        >
          <div
            className="absolute inset-x-0 rounded-full bg-white/80"
            style={{ height: thumb.height, top: thumb.top }}
          />
        </div>
      )}
    </div>
  );
}

function MobileBottomNav() {
  const location = useLocation();
  const active = (path) => location.pathname === path;
  const [servicesOpen, setServicesOpen] = useState(false);
  const [activeGroup, setActiveGroup] = useState(serviceGroups[0].title);

  const isServicesActive = location.pathname.startsWith("/services");

  return (
    <>
      {/* Services sheet — slides up from bottom */}
      {servicesOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm md:hidden"
            onClick={() => setServicesOpen(false)}
          />
          {/* Sheet */}
          <div
            className="fixed bottom-[72px] left-0 right-0 z-50 rounded-t-2xl border-t border-white/10 px-4 pt-5 pb-6 shadow-2xl md:hidden"
            style={{ backgroundColor: PANEL_BG }}
          >
            {/* Handle */}
            <div className="mx-auto mb-4 h-1 w-10 rounded-full bg-white/20" />
            <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.18em] text-white/40">
              Our Services
            </p>
            <div className="flex max-h-[60vh] flex-col gap-1 overflow-y-auto">
              {serviceGroups.map((group) => {
                const open = activeGroup === group.title;
                return (
                  <div key={group.title}>
                    <button
                      type="button"
                      onClick={() => setActiveGroup(open ? "" : group.title)}
                      className={`flex w-full items-center justify-between rounded-xl px-3 py-3 text-left text-sm font-semibold transition ${
                        open ? "bg-white/10 text-orange-500" : "text-white/85 hover:bg-white/10"
                      }`}
                      aria-expanded={open}
                    >
                      <span className="flex items-center gap-2.5">
                        <ServiceIcon name={group.icon} className="h-4 w-4" />
                        {group.title}
                      </span>
                      <ChevronDown className={`opacity-80 transition ${open ? "rotate-180" : ""}`} />
                    </button>
                    {open && (
                      <div className="mb-1 mt-1 flex flex-col gap-0.5 pl-2">
                        {group.items.map((item) => (
                          <Link
                            key={item.label}
                            to={item.to}
                            onClick={() => setServicesOpen(false)}
                            className={`flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm transition ${
                              location.pathname === item.to
                                ? "bg-orange-500/15 text-orange-500"
                                : "text-white/75 hover:bg-white/10 hover:text-white"
                            }`}
                          >
                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/5 text-orange-500">
                              <ServiceIcon name={item.icon} />
                            </span>
                            {item.label}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </>
      )}

      <nav className="fixed bottom-0 left-0 right-0 z-50 font-nav md:hidden">
        <div className="border-t border-white/10 bg-[#1a1a1a]/95 backdrop-blur-md px-2 pb-safe">
          <div className="flex items-end justify-around px-1 pt-2 pb-3">
            {/* Home */}
            <Link
              to="/"
              className={`flex flex-1 flex-col items-center gap-1 py-1 text-[10px] font-semibold uppercase tracking-wider transition-colors ${
                active("/") ? "text-orange-500" : "text-white/50"
              }`}
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              Home
            </Link>

            {/* Services — opens sheet */}
            <button
              type="button"
              onClick={() => setServicesOpen((v) => !v)}
              className={`flex flex-1 flex-col items-center gap-1 py-1 text-[10px] font-semibold uppercase tracking-wider transition-colors ${
                isServicesActive || servicesOpen ? "text-orange-500" : "text-white/50"
              }`}
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Services
            </button>

            {/* Get Quote — centre */}
            <div className="flex flex-col items-center px-3 -mt-5">
              <Link
                to="/contact"
                className="flex flex-col items-center justify-center gap-0.5 rounded-2xl bg-orange-500 px-5 py-3 shadow-xl shadow-orange-500/40 transition hover:bg-orange-600 active:scale-95"
              >
                <svg className="h-5 w-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" />
                </svg>
                <span className="text-[10px] font-bold uppercase tracking-wider text-white">Quote</span>
              </Link>
            </div>

            {/* FAQ */}
            <Link
              to="/faq"
              className={`flex flex-1 flex-col items-center gap-1 py-1 text-[10px] font-semibold uppercase tracking-wider transition-colors ${
                active("/faq") ? "text-orange-500" : "text-white/50"
              }`}
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              FAQ
            </Link>

            {/* Careers */}
            <Link
              to="/careers"
              className={`flex flex-1 flex-col items-center gap-1 py-1 text-[10px] font-semibold uppercase tracking-wider transition-colors ${
                active("/careers") ? "text-orange-500" : "text-white/50"
              }`}
            >
              <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Careers
            </Link>
          </div>
        </div>
      </nav>
    </>
  );
}

export default function Navbar() {
  const [locationsOpen, setLocationsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [activeGroup, setActiveGroup] = useState(serviceGroups[0].title);
  const [activeState, setActiveState] = useState(stateData[0].id);
  const location = useLocation();
  const locRef = useRef(null);
  const servicesRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (locRef.current && !locRef.current.contains(e.target)) {
        setLocationsOpen(false);
      }
      if (servicesRef.current && !servicesRef.current.contains(e.target)) {
        setServicesOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const pathActive = (path) => location.pathname === path;

  const linkBase =
    "font-nav text-[0.88rem] font-medium uppercase tracking-[0.08em] text-white/70 transition-colors whitespace-nowrap hover:text-white";
  const linkActive = "text-orange-500";

  return (
    <header className="sticky top-0 z-50 border-transparent bg-transparent">
      <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
        <nav
          className="mx-auto flex max-w-5xl flex-col gap-3 rounded-full border border-white/10 px-3 py-2 shadow-xl shadow-black/25 sm:px-5 sm:py-2.5 md:flex-row md:items-center md:justify-between md:gap-4"
          style={{ backgroundColor: PANEL_BG }}
        >
          {/* Logo */}
          <div className="flex items-center md:contents">
            <Link to="/" className="flex min-w-0 items-center md:shrink-0">
              <img
                src={HEADER_LOGO_SRC}
                alt="Focus Traffic Plans"
                className="h-8 w-auto max-w-[min(100%,220px)] object-contain object-left sm:h-9"
                width={220}
                height={40}
                decoding="async"
              />
            </Link>
          </div>

          {/* Center links — desktop */}
          <div className="hidden flex-1 items-center justify-center gap-5 lg:gap-6 md:flex">
            <Link
              to="/"
              className={`${linkBase} ${pathActive("/") && !location.hash ? linkActive : ""}`}
            >
              Home
            </Link>
            <div
              className="relative"
              ref={servicesRef}
              onMouseEnter={() => {
                setLocationsOpen(false);
                setServicesOpen(true);
              }}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <button
                type="button"
                className={`flex items-center gap-0.5 ${linkBase} ${servicesOpen || location.pathname.startsWith("/services") ? linkActive : ""}`}
                onClick={() => setServicesOpen((v) => !v)}
                aria-expanded={servicesOpen}
              >
                Services
                <ChevronDown className={`opacity-80 transition ${servicesOpen ? "rotate-180" : ""}`} />
              </button>
              {servicesOpen && (
                <div className="absolute left-1/2 top-full z-20 -translate-x-1/2 pt-3">
                  <div
                    className="flex w-[min(42rem,calc(100vw-2rem))] origin-top rounded-2xl border border-white/10 shadow-2xl shadow-black/40"
                    style={{ backgroundColor: PANEL_BG }}
                  >
                    <div className="w-56 shrink-0 border-r border-white/10 py-3">
                      {serviceGroups.map((group) => {
                        const active = activeGroup === group.title;
                        return (
                          <button
                            key={group.title}
                            type="button"
                            onMouseEnter={() => setActiveGroup(group.title)}
                            onClick={() => setActiveGroup(group.title)}
                            className={`flex w-full items-center justify-between whitespace-nowrap px-4 py-3 text-left text-sm font-semibold transition ${
                              active ? "bg-white/10 text-orange-500" : "text-white/80 hover:bg-white/5 hover:text-white"
                            }`}
                            aria-expanded={active}
                          >
                            <span className="flex items-center gap-2.5">
                              <ServiceIcon name={group.icon} className="h-4 w-4" />
                              {group.title}
                            </span>
                            <ChevronDown className={`-rotate-90 opacity-70 ${active ? "text-orange-500" : ""}`} />
                          </button>
                        );
                      })}
                    </div>
                    <div className="min-w-0 flex-1 py-3">
                      {serviceGroups
                        .find((group) => group.title === activeGroup)
                        ?.items.map((item) => (
                          <Link
                            key={item.label}
                            to={item.to}
                            onClick={() => setServicesOpen(false)}
                            className={`flex items-center gap-3 px-4 py-2.5 text-sm leading-snug transition ${
                              location.pathname === item.to
                                ? "bg-orange-500/10 text-orange-500"
                                : "text-white/80 hover:bg-white/10 hover:text-white"
                            }`}
                          >
                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/5 text-orange-500">
                              <ServiceIcon name={item.icon} />
                            </span>
                            {item.label}
                          </Link>
                        ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div
              className="relative"
              ref={locRef}
              onMouseEnter={() => {
                setServicesOpen(false);
                setLocationsOpen(true);
              }}
              onMouseLeave={() => setLocationsOpen(false)}
            >
              <button
                type="button"
                className={`flex items-center gap-0.5 ${linkBase} ${locationsOpen || location.pathname.startsWith("/locations") ? linkActive : ""}`}
                onClick={() => setLocationsOpen((v) => !v)}
                aria-expanded={locationsOpen}
              >
                Locations
                <ChevronDown className={`opacity-80 transition ${locationsOpen ? "rotate-180" : ""}`} />
              </button>
              {locationsOpen && (
                <div className="absolute left-1/2 top-full z-20 -translate-x-1/2 pt-3">
                  <div
                    className="flex w-[min(46rem,calc(100vw-2rem))] origin-top rounded-2xl border border-white/10 shadow-2xl shadow-black/40"
                    style={{ backgroundColor: PANEL_BG }}
                  >
                    <div className="w-52 shrink-0 border-r border-white/10 py-3">
                      {stateData.map((state) => {
                        const active = activeState === state.id;
                        return (
                          <button
                            key={state.id}
                            type="button"
                            onMouseEnter={() => setActiveState(state.id)}
                            onClick={() => setActiveState(state.id)}
                            className={`flex w-full items-center justify-between whitespace-nowrap px-4 py-2.5 text-left text-sm font-semibold transition ${
                              active ? "bg-white/10 text-orange-500" : "text-white/80 hover:bg-white/5 hover:text-white"
                            }`}
                            aria-expanded={active}
                          >
                            <span className="flex items-center gap-2.5">
                              <StateIcon id={state.id} className="h-5 w-5" />
                              {state.label}
                            </span>
                            <ChevronDown className={`-rotate-90 opacity-70 ${active ? "text-orange-500" : ""}`} />
                          </button>
                        );
                      })}
                    </div>
                    <div className="min-w-0 flex-1 py-3">
                      <p className="px-4 pb-2 text-[10px] font-bold uppercase tracking-[0.16em] text-white/40">
                        {stateData.find((state) => state.id === activeState)?.name}
                      </p>
                      <MenuScroll key={activeState}>
                        <div className="grid grid-cols-2">
                          {townsIn(stateData.find((state) => state.id === activeState) || stateData[0]).map((town) => {
                            const to = locationPageUrl(town) ?? "/contact";
                            return (
                              <Link
                                key={town}
                                to={to}
                                onClick={() => setLocationsOpen(false)}
                                className={`px-4 py-1.5 text-sm leading-snug transition ${
                                  location.pathname === to
                                    ? "bg-orange-500/10 text-orange-500"
                                    : "text-white/80 hover:bg-white/10 hover:text-white"
                                }`}
                              >
                                {town}
                              </Link>
                            );
                          })}
                        </div>
                      </MenuScroll>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/faq"
              className={`${linkBase} ${pathActive("/faq") ? linkActive : ""}`}
            >
              FAQ
            </Link>
            <Link
              to="/careers"
              className={`${linkBase} ${pathActive("/careers") ? linkActive : ""}`}
            >
              Careers
            </Link>
          </div>

          {/* Right: CTA */}
          <div className="hidden items-center gap-3 md:flex md:shrink-0">
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-lg bg-orange-500 px-4 py-2 font-nav text-[0.8rem] font-bold uppercase tracking-[0.07em] text-white shadow-md transition hover:bg-orange-600 active:scale-[0.98]"
            >
              <svg className="h-4 w-4" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" />
              </svg>
              Get Quote
            </Link>
          </div>
        </nav>

        {/* Bottom mobile nav */}
        <MobileBottomNav />
      </div>
    </header>
  );
}
